import React from "react";
import styles from "./Volunteering.module.css";

import { FaCalendar } from "react-icons/fa";
import { FaMapPin } from "react-icons/fa";

import XeoLogo from "../../../../../Assets/Images/Logos/Xeo.jpg"
import StiriBazateLogo from "../../../../../Assets/Images/Logos/Stiribazate.png"

const VolunteeringEntries = [
    {
        firm: "Stiri Bazate", 
        logo: StiriBazateLogo,
        title: "News Organization", 
        date: "2025 - present", 
        location: "Remote",
        content: [
            {
                type: "text", 
                content: "Stiri Bazate is a volunteer-driven news organization that began as an Instagram initiative by young journalists. I joined to help build its website from scratch, leading a team of 4 developers to deliver a modern, custom platform with it's own Content Management System, enabling the addition of unique features."
            }
        ],
        learnt: "To Lead a team of 4 developers towards a shared goal.",
        technologies: ["React", "TypeScript", "Vite", "ShadCN", "Tailwind", "Python", "Flask", "FastAPI", "Redis", "MongoDB", "Gunicorn", "Nginx", "Docker", "AWS Elastic Container Service", "AWS S3", "Cloudflare"]
    },
    {
        firm: "Team Xeo", 
        logo: XeoLogo,
        title: "Robotics team", 
        date: "2019 - 2022", 
        location: "Alba Iulia, Romania",
        content: [
            {
                type: "text", 
                content: "Developed Java code for our competition robot, gaining hands-on experience with embedded systems and electronics. Built the team's website and a web app with live leaderboards that supported over 100 concurrent users during a three-day event. As part of FIRST Tech Challenge, the world's largest high school robotics competition, our team earned multiple national and international awards."
            }
        ],
        learnt: "To work together as a team with multiple technical and non-technical departments, to document my code, to work under pressure.",
        technologies: ["Java", "HTML5", "CSS", "Bootstrap", "Javascript", "Python", "Flask", "MongoDB", "Git"]
    }
]

const Volunteering = ({  }) => {
    return (
        <div className={styles.container}>
            <div className={styles.timeline}>
                {VolunteeringEntries.map((entry) => (
                    <div key={`${entry.firm}-${entry.date}`} className={styles.entry}>
                        <div className={styles.entryHeader}>
                            <img src={entry.logo} alt={`${entry.firm} logo`} className={styles.logo} />
                            <div className={styles.headerTexts}>
                                <div className={styles.headerTopRow}>
                                    <p className={styles.firm}>{entry.firm}</p>
                                    <div className={styles.textAndIconContainer}>
                                        <p className={styles.date}>{entry.date}</p>
                                        <FaCalendar className = {styles.icon} />
                                    </div>
                                </div>
                                <div className={styles.headerBottomRow}>
                                    <p className={styles.title}>{entry.title}</p>
                                    <div className={styles.textAndIconContainer}>
                                        <p className={styles.location}>{entry.location}</p>
                                        <FaMapPin className = {styles.icon} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={styles.content}>
                            {entry.content.map((section, idx) => {
                                if (section.type === "text") {
                                    return (
                                        <p key={idx} className={styles.paragraph}>{section.content}</p>
                                    );
                                }
                                if (section.type === "list") {
                                    return (
                                        <ul key={idx} className={styles.list}>
                                            {section.content.map((item, i) => (
                                                <li key={i} className={styles.listItem}>{item}</li>
                                            ))}
                                        </ul>
                                    );
                                }
                                return null;
                            })}
                        </div>

                        {entry.learnt && (
                            <div className={styles.learnt}>
                                <span className={styles.learntLabel}>Learnt:</span>
                                <span className={styles.learntText}>{entry.learnt}</span>
                            </div>
                        )}

                        {!!entry.technologies?.length && (
                            <div className={styles.techList}>
                                {entry.technologies.map((tech) => (
                                    <span key={tech} className={styles.techPill}>{tech}</span>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Volunteering;